import { cn } from './utils/cn';

/**
 * An inline placeholder shaped to match the content it stands in for,
 * animated while data loads.
 *
 * @example
 * // Avatar plus two lines, mirroring a list item row
 * <Stack direction="horizontal" gap={3} align="center">
 *   <Skeleton className="size-10 rounded-full" />
 *   <Stack gap={2} fullWidth={false}>
 *     <Skeleton className="h-4 w-40" />
 *     <Skeleton className="h-3 w-24" />
 *   </Stack>
 * </Stack>
 */
function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="skeleton"
      className={cn('animate-pulse rounded-md bg-muted', className)}
      {...props}
    />
  );
}

export { Skeleton };
